const fix = file => file.replace(/( )+.m4a$/i, '.m4a')

export default {
  song (file) {
    return 'https://vybroo.net' + fix(file)
  },

  spot (file) {
    const base = process.env.NODE_ENV === 'development'
      ? 'http://127.0.0.1:8000/spots/'
      : '/spots/'
    return base + fix(file)
  }
}
